"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MAX_MEETING_TRANSCRIPT_LENGTH () {
        return _models.MAX_MEETING_TRANSCRIPT_LENGTH;
    },
    get MeetingTranscriptModel () {
        return MeetingTranscriptModel;
    },
    get countTranscriptCharacters () {
        return _models.countTranscriptCharacters;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("./base");
const MeetingTranscriptModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    meetingId: _utilsisomorphic.transformObjectId,
    content: _zod.z.string().refine((s)=>(0, _models.countTranscriptCharacters)(s) <= _models.MAX_MEETING_TRANSCRIPT_LENGTH, {
        message: `String must contain at most ${_models.MAX_MEETING_TRANSCRIPT_LENGTH} character(s)`
    }),
    created: _base.UserActionRecord,
    updated: _base.UserActionRecord
});
